<div class="shortage-container">
    <div class="shortage-header">
        <span class="shortage-title">{{ 'Home.drugshortages' | translate }}</span>
    </div>

    <div class="shortage-body">
      <div [innerHTML]="shortageHtml">
        <!-- Mock event HTML will be injected here -->
      </div>
      <div class="shortage-link">
        <a href="javascript:void(0)" (click)="onReadAllClick()">{{ 'Home.readmore' | translate }}</a>
      </div>
  </div>
        
</div>
